<template>
    <div>
        <!-- Filter dropdown for daily, weekly, monthly, and yearly -->
        <select v-if="showFilter.value" v-model="selectedFilter" @change="setFilter(selectedFilter)">
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
        </select>
        <div :style="chartContainerStyle">
            <BarChart v-bind="{ options, data }" />
        </div>
    </div>
</template>
  
  <script>
  import moment from "moment";
  import BarChart from "./bar.vue";
  
  export default {
	name: "AppealsLineChart",
	components: {
	  BarChart
	},
	props: {
		hideTitle: {
			type: Boolean,
			default: false,
		},
		startDate: {
			type: Object,
			default: () => {
				return moment().startOf('month');
			},
		},
		endDate: {
			type: Object,
			default: () => {
				return moment().endOf('month');
			},
		},
		params: {
			type: Object,
			default: () => ({})
		},
		showFilter: {
            type: Object,
            default: () => ({ value: true, defaultSelected: 'daily' }) // Default value with defaultSelected 'daily'
        }
	},
	data() {
	  return {
		loading: false,
		labelFormat: "MM-DD-YYYY",
		dateFormat: "YYYY-MM-DD",
		filter: this.showFilter.defaultSelected || 'monthly',
		appeals: {
			new: [],
			created: [],
			closed: [],
			submitted: [],
			inProcess: [],
		},
		options: {
		  responsive: true,
		  maintainAspectRatio: false,
		  elements: {
			point: {
			  radius: 3
			}
		  },
		  scales: {
			y: {
			  beginAtZero: true,
			  ticks: {
				stepSize: 1,
				precision: 0
			  }
			},
			x: {
				beginAtZero: true,
				ticks: {
					stepSize: 7,
					precision: 0
				}
			}
		  },
		  plugins: {
			title: {
			  display: !this.hideTitle,
			  text: "Appeals"
			}
		  }
		}
	  };
	},
	computed: {
	  chartContainerStyle() {
		return {
		  position: "relative",
		  height: "300px", // Fixed height
		  width: "100%"
		};
	  },
	  labels() {
		const days = [];
		let day = this.startDate.clone();
		const endDate = this.endDate.clone();

		while (day <= endDate) {
			// days.push(day.format(this.labelFormat));
			if (this.filter === "daily") {
				days.push(day.format(this.labelFormat))
				day = day.clone().add(1, "d");
			} else if (this.filter === "weekly") {
				// days.push(day.format(this.labelFormat))
				// day = day.clone().add(7, "d");
				// Determine the start of the current week and the previous week
				// Get the start of the previous week
				let startOfPreviousWeek = moment().startOf('week').startOf('day').subtract(1, 'week');

				// Loop for two weeks (previous and current)
				for (let i = 0; i < 14; i++) {
					// Push the weekday name
					days.push(startOfPreviousWeek.add(1, 'day').format('ddd'));
				}
				return days;

			} else if (this.filter === "monthly") {
				// Add each month label only once
				for (let month = 0; month < 12; month++) {
					const currentDate = moment().year(day.year()).month(month);
					days.push(currentDate.format('MMM'));
				}
				
				return days;
			} else if (this.filter === "yearly") {
				days.push(moment().year());
				
				return days;
			}
		}
	
		return days;
	},
	  data() {
			return {
				labels: this.labels,
				datasets: [
					{
						label: "New",
						borderColor: "rgb(0, 100, 178)",
						backgroundColor: "rgb(0, 143, 65)",
						// data: this.labels.map(label => this.appeals.created[label] || 0),
						// data: this.filter === 'weekly' ? this.calculateWeeklyData() : this.calculateDefaultData(),
						data: this.getInputdataForAppealsNew()
					},
					{
						label: "Open",
						borderColor: "rgb(0, 100, 178)",
						backgroundColor: "rgb(0, 143, 255)",
						// data: this.labels.map(label => this.appeals.created[label] || 0),
						// data: this.filter === 'weekly' ? this.calculateWeeklyData() : this.calculateDefaultData(),
						data: this.getInputdataForAppealsCreated()
					},
					// {
					// 	label: "In Process",
					// 	borderColor: "rgb(0, 85, 153)",
					// 	backgroundColor: "rgb(0, 114, 204)",
					// 	// data: this.filter === 'weekly' ? this.calculateWeeklyInProcessData() : this.calculateDefaultInProcessData(),
					// 	data: this.getInputdataForAppealsInProcess()
					// },
					{
						label: "Submitted",
						borderColor: "rgb(52, 62, 84)",
						backgroundColor: "rgb(84, 100, 135)",
						// data: this.filter === 'weekly' ? this.calculateWeeklySubmittedData() : this.calculateDefaultSubmittedData(),
						data: this.getInputdataForAppealSubmitted()
					},
					{
						label: "Closed",
						borderColor: "rgb(93, 109, 145)",
						backgroundColor: "rgb(142, 167, 222)",
						// data: this.labels.map(label => this.appeals.closed[label] || 0),
						// data: this.filter === 'weekly' ? this.calculateWeeklyClosedData() : this.calculateDefaultClosedData(),
						data: this.getInputdataForAppealClosed(),
					},
					
					
				],
			};
		},
	},
	watch: {
	  filter() {
		this.setLabelFormat();
		this.refresh();
	  }
	},
	mounted() {
		this.setLabelFormat();
	  	this.refresh();
	},
	methods: {
		setFilter(filter) {
			this.filter = filter;
			this.$emit('filterChanged', filter);
		},
		setLabelFormat() {
			if (this.filter === "daily") {
				this.labelFormat = "MM-DD-YYYY";
			} else if (this.filter === "weekly") {
				this.labelFormat = "MM-DD-YYYY"; // Display weekdays
			} else if (this.filter === "monthly") {
				this.labelFormat = "MM-YYYY";
			}
		},
		async refresh() {
			try {
				this.loading = true;

				let startDate = this.startDate.clone().startOf('day'); // Clone the startDate and set it to the start of the day
				let endDate = this.endDate.clone().endOf('day'); // Clone the endDate and set it to the end of the day				
				let response = {};
				
				if(this.filter == "daily"){
					response = await this.$store.dispatch("charts/appeals", {
						start: this.startDate.format(this.dateFormat),
						end: this.endDate.add(7, "days").format(this.dateFormat),
						params: this.params,
					});
				}else if (this.filter === "weekly") {
					// Calculate the start and end dates for the current week
					let startDateCurrentWeek = moment().startOf('week').startOf('day');
					let endDateCurrentWeek = moment().endOf('week').endOf('day');

					// Calculate the start and end dates for the previous week
					let startDatePreviousWeek = startDateCurrentWeek.clone().subtract(1, 'week');
					let endDatePreviousWeek = endDateCurrentWeek.clone().subtract(1, 'week');

					// Set labels to display weekdays for the current week
					let labelsCurrentWeek = [];
					let dayCurrentWeek = startDateCurrentWeek.clone();
					while (dayCurrentWeek <= endDateCurrentWeek) {
						labelsCurrentWeek.push(dayCurrentWeek.format(this.labelFormat));
						dayCurrentWeek.add(1, 'day');
					}

					// Set labels to display weekdays for the previous week
					let labelsPreviousWeek = [];
					let dayPreviousWeek = startDatePreviousWeek.clone();
					while (dayPreviousWeek <= endDatePreviousWeek) {
						labelsPreviousWeek.push(dayPreviousWeek.format(this.labelFormat));
						dayPreviousWeek.add(1, 'day');
					}

					// Merge labels for both weeks
    				let labels = labelsPreviousWeek.concat(labelsCurrentWeek);

					// Change labels to display weekdays for last 7 days
					// this.labels = [];
					// for (let i = 0; i < 7; i++) {
					// 	this.labels.push(startDate.format(this.labelFormat));
					// 	startDate.add(1, 'day');
					// }
					// response = await this.$store.dispatch("charts/appeals", {
					// 	start: startDate.format(this.dateFormat),
					// 	end: endDate.format(this.dateFormat),
					// 	params: this.params,
					// });
					
					// Fetch data for both weeks
					response = await this.$store.dispatch("charts/appeals", {
						start: startDatePreviousWeek.format(this.dateFormat),
						end: endDateCurrentWeek.format(this.dateFormat),
						params: this.params,
					});
					// Extracting labels from all categories
					// const allCategories = ["inProcess", "submitted", "closed", "created"];
					// const allLabels = allCategories.reduce((labels, category) => {
					// 	labels.push(...Object.keys(response[category] ?? {}));
					// 	return labels;
					// }, []);

					// // Remove duplicates and sort labels
					// this.labels = Array.from(new Set(allLabels)).sort();
				} else if (this.filter === "monthly") {
					startDate.startOf('month');
					endDate.endOf('month');
					response = await this.$store.dispatch("charts/appeals", {
						start: this.startDate.format(this.dateFormat),
						end: this.endDate.add(7, "days").format(this.dateFormat),
						params: this.params,
					});
				}

				
			

				// Handle response data as needed
				this.appeals = {
				new: response.new ?? [],
				created: response.created ?? [],
				closed: response.closed ?? [],
				submitted: response.submitted ?? [],
				inProcess: response.inProcess ?? [],
				totalNew: response.totalNew ?? [],
				totalOpen: response.totalOpen ?? [],
				totalInProcess: response.totalInProcess ?? [],
				totalSubmitted: response.totalSubmitted ?? [],
				totalClosed: response.totalClosed ?? [],
				};
				this.$emit("appealDataLoaded", this.appeals);
				
			} finally {
				this.loading = false;
			}
		},
		calculateWeeklyData() {
			
			const weeklyData = [];
			for (let i = 0; i < this.labels.length - 1; i++) {
				const startDate = moment(this.labels[i], 'ddd');
				const endDate = moment(this.labels[i + 1], 'ddd').subtract(1, 'day');
				let totalCount = 0;
				Object.keys(this.appeals.created).forEach(date => {
					const createdDate = moment(date, this.labelFormat);
					if (createdDate.isBetween(startDate, endDate, null, '[]')) {
						totalCount += this.appeals.created[date];
					}
				});
				weeklyData.push(totalCount);
			}
			
			return weeklyData;
		},
		calculateDefaultData() {
			return this.labels.map(label => this.appeals.created[label] || 0);
		},
		calculateWeeklyNewData(){
		
			const weeklyData = [];
			for (let i = 0; i < this.labels.length - 1; i++) {
				const startDate = moment(this.labels[i], 'ddd');
				const endDate = moment(this.labels[i + 1], 'ddd').subtract(1, 'day');
				let totalCount = 0;

				Object.keys(this.appeals.new).forEach(date => {
					const createdDate = moment(date, this.labelFormat);
					if (createdDate.isBetween(startDate, endDate, null, '[]')) {
						totalCount += this.appeals.new[date];
					}
				});
				weeklyData.push(totalCount);
			}
			
			return weeklyData;
		},
		calculateDefaulNewtData(){
			return this.labels.map(label => this.appeals.new[label] || 0);
		},
		calculateWeeklyClosedData() {
			const weeklyData = [];
			for (let i = 0; i < this.labels.length - 1; i++) {
				const startDate = moment(this.labels[i], 'ddd');
				const endDate = moment(this.labels[i + 1], 'ddd').subtract(1, 'day');
				let totalCount = 0;
				Object.keys(this.appeals.closed).forEach(date => {
					const closedDate = moment(date, this.labelFormat);
					if (closedDate.isBetween(startDate, endDate, null, '[]')) {
						totalCount += this.appeals.closed[date];
					}
				});
				weeklyData.push(totalCount);
			}
			return weeklyData;
		},
		calculateDefaultClosedData() {
			return this.labels.map(label => this.appeals.closed[label] || 0);
		},
		calculateWeeklyInProcessData() {
			const weeklyData = [];
			for (let i = 0; i < this.labels.length - 1; i++) {
				const startDate = moment(this.labels[i], this.labelFormat);
				const endDate = moment(this.labels[i + 1], this.labelFormat).subtract(1, 'day');
				let totalCount = 0;
				Object.keys(this.appeals.inProcess).forEach(date => {
					const inProcessDate = moment(date, this.labelFormat);
					if (inProcessDate.isBetween(startDate, endDate, null, '[]')) {
						totalCount += this.appeals.inProcess[date];
					}
				});
				weeklyData.push(totalCount);
			}
			return weeklyData;
		},
		calculateDefaultInProcessData() {
			return this.labels.map(label => this.appeals.inProcess[label] || 0);
		},
		calculateWeeklySubmittedData() {
			const weeklyData = [];
			for (let i = 0; i < this.labels.length - 1; i++) {
				const startDate = moment(this.labels[i], 'ddd');
				const endDate = moment(this.labels[i + 1], 'ddd').subtract(1, 'day');
				let totalCount = 0;
				Object.keys(this.appeals.submitted).forEach(date => {
					const submittedDate = moment(date, this.labelFormat);
					if (submittedDate.isBetween(startDate, endDate, null, '[]')) {
						totalCount += this.appeals.submitted[date];
					}
				});
				weeklyData.push(totalCount);
			}
			return weeklyData;
		},
		calculateDefaultSubmittedData() {
			return this.labels.map(label => this.appeals.submitted[label] || 0);
		},
		calculateMonthlyData(data) {
			const monthlyData = [];
			
			for (let i = 0; i < this.labels.length - 1; i++) {
				const startDate = moment(this.labels[i], 'MMM-YY');
    			const endDate = moment(this.labels[i + 1], 'MMM-YY').endOf('month');
				let totalCount = 0;
				Object.keys(data).forEach(date => {
					const currentDate = moment(date, 'MM-DD-YYYY');
					// console.log('startDate is:', startDate);
					// console.log('endDate is:', endDate);
					// console.log('createddate is:', currentDate);
					if(currentDate.isBetween(startDate, endDate, null, '[]')) {
						// console.log('match found');
						totalCount += data[date];
					}
				});
				monthlyData.push(totalCount);
			}
			
			return monthlyData;
		},
		getInputdataForAppealsNew(){
			if(this.filter === 'weekly'){
				return this.calculateWeeklyNewData();
			}else if(this.filter === 'daily'){
				return this.calculateDefaulNewtData();
			}else if(this.filter === 'monthly'){
				return this.calculateMonthlyData(this.appeals.new);
			}	
		},
		getInputdataForAppealsCreated(){
			if(this.filter === 'weekly'){
				return this.calculateWeeklyData();
			}else if(this.filter === 'daily'){
				return this.calculateDefaultData();
			}else if(this.filter === 'monthly'){
				return this.calculateMonthlyData(this.appeals.created);
			}	
		},
		getInputdataForAppealsInProcess(){
			if(this.filter === 'weekly'){
				return this.calculateWeeklyInProcessData();
			}else if(this.filter === 'daily'){
				return this.calculateDefaultInProcessData();
			}else if(this.filter === 'monthly'){
				return this.calculateMonthlyData(this.appeals.inProcess);
			}	
		},
		getInputdataForAppealSubmitted(){
			if(this.filter === 'weekly'){
				return this.calculateWeeklySubmittedData();
			}else if(this.filter === 'daily'){
				return this.calculateDefaultSubmittedData();
			}else if(this.filter === 'monthly'){
				return this.calculateMonthlyData(this.appeals.submitted);
			}	
		},
		getInputdataForAppealClosed(){
			if(this.filter === 'weekly'){
				return this.calculateWeeklyClosedData();
			}else if(this.filter === 'daily'){
				return this.calculateDefaultClosedData();
			}else if(this.filter === 'monthly'){
				return this.calculateMonthlyData(this.appeals.closed);
			}	
		}
	}
};
</script>